<template lang="pug">
  .form
    .form__elem
      .upload-photo
        .upload-photo__img
          .upload-photo-img(
          v-bind:style="getLocalAvatarUrl(localAvatar.file)"
          )
        .upload-photo__body
          .drop-area
            .drop-area__title.drop-area-title
              .drop-area-title__icon
                img(src="@/assets/images/icons/clip.svg")
              .drop-area-title__text Добавить фото ребенка
            .drop-area__description Максимум 3 мб. JPG
            .input-file
              label.input-file__label
                input.input-file__input(
                type="file"
                @change="onAddAvatar($event)"
                )
                .input-file__outline

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.last_name }"
      )
        .form-elem__title Фамилия ребенка
        .form-elem__body
          input.input.input_full.input_capitalize(
          v-model="localLastName"
          v-on:keyup="keymonitor"
          maxlength=50
          )

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.first_name }"
      )
        .form-elem__title Имя ребенка
        .form-elem__body
          input.input.input_full.input_capitalize(
            v-model="localFirstName"
            v-on:keyup="keymonitor"
            maxlength=50
          )

    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.fathers_name }"
      )
        .form-elem__title Отчество ребенка
        .form-elem__body
          input.input.input_full.input_capitalize(
            v-model="localFathersName"
            v-on:keyup="keymonitor"
            maxlength=50
          )

    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.gender }"
      )
        .form-elem__title Пол ребенка
        .form-elem__body
          simple-select-form(
            :list-data="genderListData"
            :default-value="localGender"
            :enable-default-value-class="true"
            @onChangeDefaultValue="changeGenderValue"
          )
    .form__elem.form__elem_short
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.date_of_birth }"
      )
        .form-elem__title Дата рождения ребенка
        .form-elem__body
          date-picker(
            placeholder="дд.мм.гггг"
            v-model="localDateOfBirth"
            format="DD.MM.YYYY"
            lang="ru"
            input-class="input input_full"
            @change="onChangeDate($event)"
            :clearable="false"
            :editable="true"
            :not-after="new Date()"
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.nationality }"
      )
        .form-elem__title Гражданство
        .form-elem__body
          input.input.input_full(
            v-model="localNationality"
            v-on:keyup="keymonitor"
            maxlength=32
          )
    .form__elem
      .form-elem.form-elem_horizontal(
        :class="{ 'form-elem_error' : requireErrors.place_of_birth }"
      )
        .form-elem__title Место рождения
        .form-elem__body
          multiselect.custom-multiselect(
            v-model="localPlaceOfBirth"
            placeholder="Выберите место рождения",
            :options="citiesList"
            :label="'value'"
            :multiple="false"
            :showLabels="false"
            :closeOnSelect="true"
            :allowEmpty="true"
            :clearOnSelect="false"
            @search-change="asyncFindPlaceOfBirth"
          )
            template(
              slot="noOptions"
            ) Начните вводить название населенного пункта
            template(
              slot="noResult"
            ) Ничего не найдено
</template>
<script>
import {mapActions} from "vuex";

import SimpleSelectForm from "@/components/simpleSelectForm/SimpleSelectForm.vue";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";

export default {
  name: "FormChildInfo",
  components: {
    SimpleSelectForm,
    DatePicker,
    Multiselect
  },
  props: {
    avatar: {
      type: Object,
      default: () => ({})
    },
    lastName: {
      type: String,
      default: ""
    },
    firstName: {
      type: String,
      default: ""
    },
    fathersName: {
      type: String,
      default: ""
    },
    gender: {
      type: [Boolean, Object, String],
      default: null
    },
    dateOfBirth: {
      type: [String, Object],
      default: ""
    },
    nationality: {
      type: [String, Object],
      default: ""
    },
    placeOfBirth: {
      type: [String, Object],
      default: ""
    },
    requireErrors: {
      type: Object,
      default: () => ({})
    },
    keymonitor: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      genderListData: [
        {
          text: "Мальчик",
          value: true
        },
        {
          text: "Девочка",
          value: false
        }
      ],
      citiesList: [],
      interval: null,
      url: "suggest/address"
    };
  },
  computed: {
    localAvatar: {
      get() {
        return this.avatar;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "avatar"]);
      }
    },
    localLastName: {
      get() {
        return this.lastName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "last_name"]);
      }
    },
    localFirstName: {
      get() {
        return this.firstName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "first_name"]);
      }
    },
    localFathersName: {
      get() {
        return this.fathersName;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "fathers_name"]);
      }
    },
    localGender: {
      get() {
        if (this.gender === null) {
          return {
            text: "Пол",
            value: null
          };
        }
        return this.genderListData.find(el => el.value === this.gender);
      },
      set() {}
    },
    localDateOfBirth: {
      get() {
        if (!this.dateOfBirth) {
          return "";
        }
        return this.dateOfBirth;
      },
      set() {}
    },
    localNationality: {
      get() {
        return this.nationality;
      },
      set(value) {
        this.$emit("onChangeValue", [value, "nationality"]);
      }
    },
    localPlaceOfBirth: {
      get() {
        return {
          value: this.placeOfBirth
        };
      },
      set(value) {
        let unrestrictedValue = "";
        if (value) {
          unrestrictedValue = value.unrestricted_value;
        }
        this.$emit("onChangeValue", [unrestrictedValue, "place_of_birth"]);
      }
    }
  },
  methods: {
    ...mapActions(["addAttachments", "getSuggetionDaData"]),
    changeGenderValue(data) {
      this.$emit("onChangeValue", [data.value, "gender"]);
      this.keymonitor();
    },
    onAddAvatar(e) {
      const file = e.target.files[0];
      const formData = new FormData();
      const type = "2"; // avatar
      if (!file || !type) {
        return;
      }
      formData.append("file", file);
      formData.append("attachment_type", type);
      this.addAttachments(formData).then(response => {
        this.localAvatar = response.data;
      });
      e.target.value = "";
    },
    onChangeDate(date) {
      const d = new Date(date);
      const _date = `${d.getFullYear()}-${("0" + (d.getMonth() + 1)).slice(
        -2
      )}-${("0" + d.getDate()).slice(-2)}`;
      this.$emit("onChangeValue", [_date, "date_of_birth"]);
      this.$emit("onChangeChildBirth", _date);
    },
    getLocalAvatarUrl(url) {
      return url ? "background-image: url(" + url + ")" : "";
    },
    asyncFindPlaceOfBirth(query) {
      this.keymonitor();
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        const params = {
          query: query,
          count: 10,
          from_bound: {
            value: "city"
          },
          to_bound: {
            value: "settlement"
          }
        };
        this.getSuggetionDaData({
          data: params,
          url: this.url
        }).then(suggetion => {
          this.citiesList = suggetion.data.suggestions;
        });
        clearInterval(this.interval);
      }, 500);
    }
  }
};
</script>
